import { serviceProvider } from "../../../../../comun/provider/ServiceProvider";
import { BaseFullScreenModalRender } from "../../../../base/modal/BaseFullScreenModalRender";
import { IConnectRender } from "../../../../definitions/IConnectRender";
import { AplicacionesConfiguracionContentRender } from "./AplicacionesConfiguracionContentRender";

/** Modal full-screen de configuración del módulo de aplicaciones. Se abre desde
 *  el ítem "Configuración" del grupo Aplicaciones del menú, igual que los de
 *  monitoreo y ganadería. No lleva botón guardar: cada sección persiste sola,
 *  así que la barra solo trae el botón de volver. */
export class AplicacionesConfiguracionModal extends BaseFullScreenModalRender {
  /** Id del elemento raíz auto-montado en `body`. */
  protected readonly elementId = "aplicacionesConfiguracionModal";

  /** Título de la barra superior. */
  protected get title(): string {
    return "Configuración de aplicaciones";
  }

  /** Subtítulo de la barra: nombre de la finca activa. Lo que se configura acá
   *  es del **cliente**, pero el subtítulo nombra la finca igual que el resto de
   *  los modales para no romper la referencia de dónde está parado el usuario;
   *  que el alcance es el cliente lo dice la propia sección. */
  protected get subtitle(): string {
    return serviceProvider.getFincaSelectedService().getRequired().nombreFinca;
  }

  /** Cuerpo del modal con las secciones de configuración. */
  protected getContent(): IConnectRender {
    return new AplicacionesConfiguracionContentRender();
  }
}
